import { render, staticRenderFns } from "./styleguide.vue?vue&type=template&id=469092c4&"
import script from "./styleguide.vue?vue&type=script&lang=js&"
export * from "./styleguide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports